import type {GeocodePrecision} from "@mytour/shared";
import {
  type AddressVerification,
  type ConfirmationEvent,
  type UseAddressVerificationOptions,
  useAddressVerification as useAddressVerificationCore,
} from "@mytour/ui/form";
import {geocodeConfirmationAnalytics} from "./geocodeConfirmationAnalytics.js";
import {getGeocode} from "./services/geocode.service.js";

type Options = Omit<UseAddressVerificationOptions, "getGeocode" | "onConfirmationEvent">;

/**
 * `useAddressVerification` de `@mytour/ui/form`, pré-lié au géocodeur de la
 * plateforme (`getGeocode`) et à la télémétrie de la confirmation bloquante
 * (#920) — le point d'entrée des formulaires de l'app. Le hook de `@mytour/ui`
 * reste la version injectable : `ui` ne dépend pas de `platform`, et un
 * contexte à géocodeur différent (ex. la route publique du tunnel RDV) peut
 * l'utiliser directement avec le sien.
 */
export function useAddressVerification(options: Options): AddressVerification {
  return useAddressVerificationCore({
    ...options,
    getGeocode,
    onConfirmationEvent: trackConfirmationEvent,
  });
}

// Identité stable (module-level) : le hook peut la référencer sans re-déclenchement.
function trackConfirmationEvent(event: ConfirmationEvent, precision: GeocodePrecision | null) {
  geocodeConfirmationAnalytics[event](precision);
}
